import React, { useState } from "react";
import { Col, Image } from "react-bootstrap";
import { MessageModal } from "../message-info.modal";
import piyushGoelImg from "../../../assets/piyush-goel.png";
import PG from "../../../assets/PG.svg";
import JP from "../../../assets/JP.svg";
import HCIMletter from "../../../assets/HCIM_Letter.png";
import styled from "styled-components";
import ZoomLevelProvider from "../../projectList/ZoomLevelProvider";

const messages = [
  {
    src: piyushGoelImg,
    name: `<h4>Shri Piyush Goyal</h4>
           <p>Minister of Commerce & Industry</p>`,
    content: `
  <p>Government has given high priority to the fast and speedy implementation of projects especially those that have been pending for a long time. Hon’ble Prime Minister Shri Narendra Modi ji has personally intervened in various pending projects and ensured their successful implementation. ...<p>
`,
    fullContent: `
        <p>Government has given high priority to the fast and speedy implementation of projects especially those that have been pending for a long time. Hon’ble Prime Minister Shri Narendra Modi ji has personally intervened in various pending projects and ensured their successful implementation.<p>
  <p>In this context, the Project Monitoring Group (PMG) plays an important role for       expediting implementation of large scale projects. It has established itself as the
  go-to investor facilitation cell for issue resolution and for the removal of regulatory bottlenecks for large-scale public, private and public private partnership projects.</p>
  <p>With the Government’s decision to infuse &#8377; 102 lakh Cr. in infrastructure in the next five years, PMG will have an instrumental role to play in ensuring timely implementation and resolving a variety of issues for expeditious commissioning of various ambitious projects for economic development and welfare. PMG is an endeavour to realise the Hon’ble Prime Minister’s mantra of 'Transform, Reform and Perform’, and I wish them success in all their future projects.</p>

    `
  }
];

export function Message() {
  const [index, setIndex] = useState(0);
  const [modalToggle, setModalToggle] = useState();
  const [zoomPercentage, setZoomPercentage] = useState("");

  function onSetIndex(type) {
    setIndex(index => (type === "prev" ? index-- : index++));
  }

  function onToggleModal() {
    setModalToggle(modalToggle => (modalToggle = !modalToggle));
  }

  const handleZoomChange = zoom => {
    setZoomPercentage(zoom);
  };

  return (
    <>
      <ZoomLevelProvider onZoomChange={handleZoomChange} />
      {modalToggle ? (
        <MessageModal
          src={messages[index].src}
          name={messages[index].name}
          content={messages[index].fullContent}
          onClose={onToggleModal}
        />
      ) : null}
      <div className="messages-container">
        <h2>Our Ministers</h2>
        <div className="messages-our-ministers">
          <div
            className="PMJP-section messages-container-body"
            // onClick={onToggleModal}
          >
            {/* <div className="box-image">
              <div className="sub-right-box">
                <div className="text">
                  <h4>Shri Piyush Goyal</h4>
                  <p>Minister of Commerce & Industry</p>
                </div>
              </div>
            </div> */}
            {/* <div className="left-box-text">
              <p>
                “Government has given high priority to the fast and speedy
                implementation of projects especially those that have been
                pending for a long time. Hon’ble Prime Minister Shri Narendra
                Modi ji has personally intervened in various pending projects
                and ensured their successful implementation.
              </p>
              <p className="margin-zero">
                In this context, the Project Monitoring Group (PMG) plays an
                important role for expediting implementation of large scale
                projects. It has established itself as the go-to investor
                facilitation cell for issue resolution and for the removal of
                regulatory bottlenecks for large-scale public, private and
                public private partnership projects.”
              </p>
              <p>With the Government’s decision to infuse &#8377; 102 lakh Cr. in infrastructure in the next five years, PMG
                  will have an instrumental role to play in ensuring timely implementation and resolving a variety of issues for
                  expeditious commissioning of various ambitious projects for economic development and welfare. PMG is an endeavour to
                  realise the Hon’ble Prime Minister’s mantra of 'Transform, Reform and Perform’, and I wish them success in all their
                  future projects.</p>
            </div> */}
            <div
              className="PG-box"
              style={{ height: zoomPercentage != 90 ? 380 : "auto" }}
            >
              <div style={{ display: "flex" }}>
                <Image style={{ padding: "20px" }} src={PG} loading="lazy" />
                <div className="separator-PG" />
                <div
                  style={{
                    marginLeft: "24px",
                    marginTop: "90px",
                    display: "flex",
                    flexDirection: "column"
                  }}
                >
                  <span className="PG-title">Shri Piyush Goyal</span>
                  <span className="PG-desig">
                    Minister of Commerce & Industry
                  </span>
                </div>
              </div>
              <div className="PG-footer">
                “PMG embodies the Hon’ble Prime Minister’s vision of Reform,
                Perform and Transform and will continue to serve as a key
                institutional mechanism in supporting India’s journey towards
                sustainable growth, economic resilience and global
                competitiveness.”
              </div>
            </div>
            <div className="JP-box">
              <div style={{ display: "flex" }}>
                <Image style={{ padding: "20px" }} src={JP} loading="lazy" />
                <div className="separator-PG" />
                <div
                  style={{
                    marginLeft: "24px",
                    marginTop: "90px",
                    display: "flex",
                    flexDirection: "column"
                  }}
                >
                  <span className="PG-title">Shri Jitin Prasada</span>
                  <span className="PG-desig">
                    Minister of State for Commerce and Industry
                  </span>
                </div>
              </div>
            </div>
          </div>
          <div className="" style={{ marginTop: "-6px" }}>
            {/* <div className="box box-one">
              <div className="sub-right-box">
                <div className="text">
                  <h4>Shri Jitin Prasada</h4>
                  <p>Minister of State for Commerce and Industry</p>
                </div>
              </div>
            </div> */}
            <Image
              src={HCIMletter}
              style={{ height: zoomPercentage == 90 ? "630px" : "654px" }}
              loading="lazy"
            />
            {/* <div className="box box-two">
              <div className="sub-right-box">
                <div className="text">
                  <h4>Shri Som Parkash</h4>
                  <p>Minister of State for Commerce and Industry</p>
                </div>
              </div>
            </div> */}
          </div>
        </div>
      </div>
    </>
  );
}
